<template>
  <div class="abilityDetails">
    <!-- 标题 -->
    <div class="month">月度健康管理建议</div>
    <div class="content">
      <!-- 顶部 -->
      <div class="suggest">
        <div>智能健康管家</div>
        <div>佩戴建议</div>
        <div>-------------------------------------------</div>
        <div class="information">
          根据您当次的检测情况,佩戴智能健康管家情况如下
        </div>
        <div class="refer">(参照图片示意位置)</div>
      </div>
      <!-- 穴位图片 -->
      <div class="acupoint">
        <img class="body" :src="bodyImg" alt="人体图" />
      </div>
      <!-- 温馨提示 -->
      <div class="Tips">
        <div class="warm">温馨提示</div>
        <ul class="list">
          <li>
            1、除建议佩戴位置,如白天有痛点:肩膀痛、膝盖痛、乳房痛、胃疼、头痛等,可根据痛点自行调整佩戴位置
          </li>
          <li>2、晚上建议戴重点;男性佩戴前列腺;女性佩戴子宫、卵巢</li>
          <li>3、智能健康管家离皮肤越近,功效越好,请尽可能接触皮肤佩戴。</li>
        </ul>
      </div>
      <!-- 食养汤方 -->
      <div class="dietaryregimen">
        <div class="way">
          <div>食养汤方</div>
          <div>-------</div>
        </div>

        <!-- 汤 -->
        <div class="food">
          <img class="soup" :src="soupImg" alt="" />
          <!-- <img class="soup" :src="foodsList.drinksPicture" alt="" /> -->
          <div class="kelp">{{ foodsList.drinksName }}</div>
          <div class="introduce">
            <div style="white-space: pre-wrap">{{ foodsList.drinksMethod }}</div>
          </div>
        </div>
        <div class="food">
          <img class="soup" :src="soupImg" alt="" />
          <!-- <img class="soup" :src="foodsList.fruitPicture" alt="" /> -->
          <div class="kelp">{{ foodsList.fruitName }}</div>
          <div class="introduce">
            <div style="white-space: pre-wrap">{{ foodsList.fruitMethod }}
            </div>
          </div>
        </div>
      </div>
      <!--底部建议  -->
      <div class="suggest bite">
        <div>饮食建议</div>
        <div>这样吃更健康</div>
        <div>----------------------------------------</div>
        <div>
          <p class="advise">1、少油、少盐、少糖饮食原则;</p>
          <p></p>
          <p class="advise">2、避免炸、煎、炒、烤、燻、烘焙的食物;</p>
          <p class="advise">
            3、任何食物勿天天吃,宣吃三天停一天,或吃六天停一天;
          </p>
          <p class="advise">
            4、勿吃加工食品:如香肠、贡丸、甜不辣、
            泡面、罐头、臭豆腐、蜜饯、肉乾、肉松、五颜六色的饮料与零食
            及精致加工的大豆制品等。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBraceletFoodInfoByUserId } from '@/api/index'
export default {
  name: 'MonthHealth',
  data () {
    return {
      foodsList: [],
      soupImg: `${this.$imgDomain}/www/HealthingCore/soup.png`,
      bodyImg: `${this.$imgDomain}/www/HealthingCore/body.png`,
    }
  },
  methods: {
    // 获取页面数据--图片--食材--做法
    getMonthHealthDataList () {
      const userId = 'Mini_068f40fc-cda9-474c-a24e-ae1c8cdb52c7'
      GetBraceletFoodInfoByUserId({ userId }).then((res) => {
        const { data } = res
        this.foodsList = data.foodsList // 所有数据
      })
    }
  },
  mounted () {
    this.getMonthHealthDataList()
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.abilityDetails {
  height:100%;
  padding: 0 20px;
  background: url('https://gotocloud8-open-sx.oss-cn-hangzhou.aliyuncs.com/www/HealthingCore/monthHealthBag.png') no-repeat;
  background-size: 100%;
  background-color: #fff;
  color: #4f4f4f;
  .month{
    font-size:20px;
    text-align:center;
    margin:-30px 0 20px 0;
  }
  .content {
    width: 100%;
    border-radius: 15px;
    background: #fff;
    padding: 15px;
    .suggest {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 20px;
      .information {
        font-size: 13px;
        margin-top: 5px;
      }
      .refer {
        font-size: 13px;
        margin-top: 3px;
        margin-left: -170px;
      }
    }
    .acupoint {
      display: flex;
      margin-top: 10px;
      .body {
        width: 100%;
        height: 500px;
      }
    }
    .Tips {
      margin-top: 20px;
      .warm {
        width: 90px;
        border-radius: 10px;
        padding: 3px;
        color: #f7f7f7;
        font-size: 16px;
        text-align: center;
        background: #5dc1b5;
      }
      .list {
        font-size: 13px;
        margin-top: 20px;
        line-height: 22px;
        color: #808080;
      }
    }
    .dietaryregimen {
      .way {
        margin-top: 25px;
        text-align: center;
        font-size: 20px;
      }
      .food {
        display: flex;
        flex-direction: column;
        align-items: center;
        .soup {
          margin: 10px 0;
        }
        .kelp {
          font-size: 17px;
        }
        .introduce {
          line-height: 25px;
          font-size: 14px;
          padding:20px 0;
        }
      }
    }
    .bite {
      padding: 10px;
      border: 1px dashed #808080;
      .advise {
        font-size: 13px;
        margin-top: 5px;
      }
    }
  }
}
</style>
